<template>
  <div>

    <div class="flex flex-column mv2">
      <date-select mode="range" v-model="dateRange" bg="light" placeholder="введите интервал"/>
    </div>

    <div v-if="dateRange" class="flex flex-column mv2 bg-light pa3">
      <span class="text-secondary">деление по</span>
      <radio v-for="p in periods" :key="p.id"
        name="contract_sort" :label="p.name" :value="p.code" v-model="period" class="mt4 mt3-l"/>
    </div>

    <div v-if="dateRange" class="flex flex-column mt4">
      <button @click="getData" class="button primary">Сформировать</button>
    </div>

  </div>
</template>

<script>
import DateSelect from '@/components/ui/DateSelect.vue'
import Radio from '@/components/ui/Radio.vue'
import { mapGetters } from 'vuex'

export default {
  props: {
    rootModule: {
      type: String,
      required: true
    },
    dateRangePlaceholder: {
      default: 'Интервал'
    }
  },
  components: {
    DateSelect,
    Radio
  },
  computed: {
    ...mapGetters('dashboard', [
      'periods'
    ]),
    period: {
      get () { return this.$store.getters[this.rootModule + '/periodType'] },
      set (value) { this.setPeriod(value) }
    },
    dateRange: {
      get () { return this.$store.getters[this.rootModule + '/dateRange'] },
      set (value) { this.setDateRange(value) }
    }
  },
  methods: {
    setPeriod (p) {
      this.$store.dispatch(this.rootModule + '/updatePeriod', p)
    },
    setDateRange (dr) {
      this.$store.dispatch(this.rootModule + '/updateDateRange', dr)
    },
    getData () {
      this.$emit('close', false)
      this.$store.dispatch('dashboard/get_data')
    }
  }
}
</script>

<style lang="scss" scoped>
.date-range-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
}
.date-range-grid-empty {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto;
}
</style>
